var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-bg"},[(_vm.bgBottom)?_c('div',{staticClass:"bg-bottom"},[_c('img',{attrs:{"src":_vm.bgBottom}})]):_vm._e(),(_vm.bgTop)?_c('div',{staticClass:"bg-top"},[_c('img',{attrs:{"src":_vm.bgTop,"show-menu-by-longpress":"true"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }